<template>
  <div class="chartBox">
    <chart-module :chartInfo="chartInfo"></chart-module>
  </div>
</template>

<script>
import chartModule from "./home_charts.vue";
export default {
  props: ["chartData"],
  components: {
    chartModule,
  },
  data() {
    return {
      chartInfo: { headName: "", id: "" },
    };
  },
  mounted() {
    this.chartInfo = this.chartData;
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.chartBox {
  display: flex;
  position: relative;
}
</style>